import { BiMoneyWithdraw } from "react-icons/bi";
import { FaMoneyBillWave, FaFileAlt, FaExchangeAlt, FaCreditCard, FaRegEnvelope } from "react-icons/fa";
import { FaShield } from "react-icons/fa6";
import { PiHandWithdraw } from "react-icons/pi";
import { useNavigate } from "react-router-dom";


export const AboutHome = ({ onGoToRegister }) => (
  <div className="min-h-screen bg-orange-50 flex flex-col md:flex-row items-center justify-center relative overflow-hidden">

    {/* ===== COLUNA ESQUERDA ===== */}
    <section className="mt-10 md:mt-0 w-full md:w-1/2 px-6 md:px-16 py-10 space-y-6">
      <h1 className="text-3xl md:text-4xl font-light text-gray-800 leading-snug">
        Crédito eficiente,<br />
        seguro e{" "}
        <span className="text-[#FA6300] font-extrabold">100% digital</span>
      </h1>

      {/* Atalhos de simulação / pedido */}
      <nav className="space-y-4">
        <ButtonItem
          icon={<FaMoneyBillWave />}
          title="Consignado INSS ( empréstimo consignado - refinanciamento - portabilidade)"
          path="/emprestimo-consignado"
        />
        <ButtonItem
          icon={<PiHandWithdraw />}
          title="Saque no cartão"
          path="/saque-cartao"
        />
        <ButtonItem
          icon={<FaCreditCard />}
          title="Cartão (cartão benefício - cartão consignado)"
          path="/cartao-beneficio"
        />
        <ButtonItem
          icon={<FaShield />}
          title="Seguro (prestamista - BMG Med e BMG familiar) "
          path="/seguro"
        />
        <ButtonItem
          icon={<BiMoneyWithdraw />}
          title="Saque FGTS"
          path="/saque-fgts"
        />
      </nav>

      {/* CTA principal */}
      <button onClick={onGoToRegister} className="mt-6 bg-[#FA6300] hover:bg-[#d45400] text-white font-bold py-3 px-6 rounded-full w-full max-w-sm transition">
        Quero me cadastrar
      </button>
    </section>

    {/* ===== COLUNA DIREITA – FOTO + BLOB ===== */}
    <section className="w-full md:w-1/2 flex justify-center relative mt-10 md:mt-0">
      {/* Blob laranja */}
      <svg
        viewBox="0 0 600 600"
        className="absolute w-[450px] h-[450px] md:w-[550px] md:h-[550px] -z-10 top-0 left-1/2 -translate-x-1/2"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          {/* degradê suave do laranja #FA6300 para um tom ligeiramente mais escuro */}
          <linearGradient id="blobGradient" gradientTransform="rotate(45)">
            <stop offset="0%" stopColor="#FA6300" />
            <stop offset="100%" stopColor="#d45400" />
          </linearGradient>
        </defs>
        <path
          fill="url(#blobGradient)"
          d="
              M433.6 323.7c36.8 54.8 51.8 123.6 22.5 165.8-29.3 42.2-103.9 58-167.2 54.7-63.2-3.2-115.1-25.7-158.7-63.1
              -43.7-37.4-78.9-89.8-80.1-146.1-1.2-56.2 31.4-116.5 77.2-162.5 45.8-45.9 104.8-77.6 162.7-70.1
              57.9 7.5 113.8 55.9 143.6 110.2z
            "
        />
      </svg>

      {/* ➜ foto do senhor segurando o celular */}
      <img
        src="/assets/homem-mexendo-celular.png" /* troque pelo caminho da sua imagem */
        alt="Cliente feliz segurando um celular"
        className="w-[300px] md:w-[360px] bg-[#FA6300] rounded-full object-contain relative z-0"
      />
    </section>
  </div>
);


function ButtonItem({ icon, title, badge, path = '/' }) {
  const navigate = useNavigate();
  return (
    <button onClick={e => navigate(path)} className="flex items-center bg-white p-4 rounded-lg shadow-sm hover:shadow-md w-full transition">
      <div className="text-[#FA6300] text-xl mr-3 shrink-0">{icon}</div>
      <div className="flex justify-between items-center w-full">
        <span className="text-sm font-medium text-gray-800">{title}</span>

        <div className="flex items-center space-x-2">
          {badge && (
            <span className="bg-[#FA6300]/10 text-[#FA6300] text-xs font-semibold px-2 py-0.5 rounded-full uppercase">
              {badge}
            </span>
          )}
          <span className="text-gray-400 text-lg leading-none">&rsaquo;</span>
        </div>
      </div>
    </button>
  );
}